import React from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonFooter,
  IonRow,
  IonCol,
  IonToggle,
  IonMenuButton,
  IonIcon
} from "@ionic/react";
import { arrowBack, funnel, menu } from "ionicons/icons";
import { completePilotName } from "../../common/StringUtils";

/**
 * Active detail view component
 */
export const ActiveDetailView = ({
  active,
  incompleteFilter,
  onBack,
  onToggleReel,
  onToggleIncomplete,
  onSelectTowingPlane,
  onSelectLifter,
  onSelectGlider,
  onSelectFirstPilot,
  onSelectSecondPilot,
  onSelectTowTask
}) => {
  const { towingPlane, lifter, glider, first, second, reel, towTask } = active;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={onBack} color="primary">
              <IonIcon icon={arrowBack} /> Zpět
            </IonButton>
            <IonButton slot="secondary" onClick={onToggleIncomplete}>
              {incompleteFilter ? 'jen neúplné' : 'všechny'} <IonIcon icon={funnel} />
            </IonButton>
          </IonButtons>
          <IonButtons slot="end">
            <IonMenuButton><IonIcon icon={menu} /></IonMenuButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <IonItem onClick={onToggleReel}>
            <IonLabel>Naviják</IonLabel>
            <IonToggle checked={reel} />
          </IonItem>
          {!reel && (
            <>
              <IonItem onClick={onSelectTowingPlane}>
                <IonLabel>Vlečná:</IonLabel>
                <div>{towingPlane ? `${towingPlane.name} ${towingPlane.registration}` : 'Není'}</div>
              </IonItem>
              <IonItem onClick={onSelectLifter}>
                <IonLabel>Vlekař:</IonLabel>
                <div>{completePilotName(lifter)}</div>
              </IonItem>
            </>
          )}
          {!(towTask && towTask.onlyTow) && (
            <>
              <IonItem onClick={onSelectGlider}>
                <IonLabel>Kluzák:</IonLabel>
                <div>{glider ? `${glider.name} ${glider.registration}` : 'Neni'}</div>
              </IonItem>
              <IonItem onClick={onSelectFirstPilot}>
                <IonLabel>První pilot:</IonLabel>
                <div>{completePilotName(first)}</div>
              </IonItem>
              {glider?.twoSeat && (
                <IonItem onClick={onSelectSecondPilot}>
                  <IonLabel>Druhý pilot:</IonLabel>
                  <div>{completePilotName(second)}</div>
                </IonItem>
              )}
            </>
          )}
          {!reel && (
            <IonItem onClick={onSelectTowTask}>
              <IonLabel>Úloha vlečné:</IonLabel>
              <div>{towTask ? towTask.name : 'vlek'}</div>
            </IonItem>
          )}
        </IonList>
      </IonContent>
      <IonFooter>
        <IonRow>
          <IonCol sizeXs="12" sizeMd="4" offsetMd="4">
            <IonButton expand="full" onClick={onBack} color="primary">
              <IonIcon icon={arrowBack} /> Zpět
            </IonButton>
          </IonCol>
        </IonRow>
      </IonFooter>
    </IonPage>
  );
};

